import React from 'react';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import ProgressBar from '@bibliocommons/shared-progress-bar';
import ImmutablePropTypes from 'react-immutable-proptypes';
import InterlibraryLoansList from '../InterlibraryLoansList';
import InterlibraryLoansTitle from '../InterlibraryLoansTitle';

class InterlibraryLoans extends BcReactComponent {

  constructor(props) {
    super(props);

    this.bindAll('renderContent');
  }

  renderContent() {
    const { items } = this.props;

    return (
      <div className="title-row">
        <InterlibraryLoansTitle />
        <InterlibraryLoansList
          items={items} />
      </div>
    );
  }

  render() {
    const { isFetching } = this.props;
    return (
      <div className="cp-interlibraryloans">
        <ProgressBar active={isFetching} />
        {this.renderContent()}
      </div>
    );
  }
}

InterlibraryLoans.propTypes = {
  user: ImmutablePropTypes.map,
  items: ImmutablePropTypes.list,
  isFetching: React.PropTypes.bool
};


export default InterlibraryLoans;



// WEBPACK FOOTER //
// ./app/components/borrowing/interlibraryLoans/InterlibraryLoans/InterlibraryLoans.jsx